import { observable } from '@legendapp/state';

import { rootStore } from '../root-store';

interface Disclaimer {
	id: string;
	closeCallback: () => void;
}

interface DisclaimerStore {
	disclaimerId: string;
	activeDisclaimer: Disclaimer | undefined;
	seenTrimlineDisclaimers: Set<string>;
}

const DISCLAIMER_ID = 'visualizer-disclaimer-portal-input';

export const disclaimerStore = observable<DisclaimerStore>({
	disclaimerId: DISCLAIMER_ID,
	activeDisclaimer: undefined,
	seenTrimlineDisclaimers: new Set<string>()
});

export const disclaimerStoreActions = {
	setSeenTrimlineDisclaimer: (trimline: string) => {
		// If disclaimer has been seen then add it to the list of seen trimlines
		const newTrimlineSet = new Set(disclaimerStore.seenTrimlineDisclaimers.get());
		newTrimlineSet.add(trimline);
		disclaimerStore.seenTrimlineDisclaimers.set(newTrimlineSet);
	},

	isDisclaimerHasBeenSeen: (modelKey: string): boolean => {
		return disclaimerStore.seenTrimlineDisclaimers.get().has(modelKey);
	},

	setActiveDisclaimer: (id?: string) => {
		if (!id) {
			return disclaimerStore.activeDisclaimer.set(undefined);
		}

		disclaimerStore.activeDisclaimer.set({
			id,
			closeCallback: () => {
				disclaimerStore.activeDisclaimer.set(undefined);
			}
		});
	},

	openDisclaimer: (id: string) => {
		disclaimerStoreActions.setActiveDisclaimer(id);
	},

	closeDisclaimer: (disableSeenTrimlineDisclaimerTracking = false) => {
		const [currentModelKey] = rootStore.currentModel.get();

		if (!disableSeenTrimlineDisclaimerTracking) {
			disclaimerStoreActions.setSeenTrimlineDisclaimer(currentModelKey);
		}

		disclaimerStore.activeDisclaimer.set(undefined);
	}
};
